/** UnreadBadge (06 §4.2) — green pill, 99+ cap, ≥20px, never clipped. */
import styles from './UnreadBadge.module.css';

export function UnreadBadge({ count }: { count: number }) {
  if (count <= 0) return null;
  return (
    <span className={styles.badge} aria-label={`${count} unread messages`}>
      {count > 99 ? '99+' : count}
    </span>
  );
}
